import {useRouter} from 'next/router';

import {SEARCH_TYPE} from '@/src/app/constants/search';
import AllCandidatesLocationFilter from '@/src/Search/components/AllCandidatesLocationFilter';
import FilterRow from '@/src/Search/components/FilterRow';
import JobPositionsFilter from '@/src/Search/components/JobPositionsFilter';
import UsersTypeFilter from '@/src/Search/components/UsersTypeFilter';
import {Separator} from '@/src/ui';

interface AllCandidatesFiltersProps {
  onMultipleFilterClickHandle: (...args: any[]) => any;
}

const AllCandidatesFilters = ({
  onMultipleFilterClickHandle,
}: AllCandidatesFiltersProps) => {
  const {query} = useRouter();

  return (
    <>
      <UsersTypeFilter
        query={query}
        onChangeHandler={onMultipleFilterClickHandle}
        withoutClinic={
          query.slug === SEARCH_TYPE.EMPLOYEES ||
          query.slug === SEARCH_TYPE.ALL_CANDIDATES
        }
      />
      <FilterRow>
        <Separator />
      </FilterRow>
      <JobPositionsFilter onChangeHandler={onMultipleFilterClickHandle} />
      <FilterRow>
        <Separator />
      </FilterRow>
      <AllCandidatesLocationFilter
        onChangeHandler={onMultipleFilterClickHandle}
      />
    </>
  );
};

export default AllCandidatesFilters;
